var base = require('settings/profile/update-contact-information');

Vue.component('spark-update-contact-information', {
  mixins: [base],
  watch: {
    'form.successful'() {
      if (this.form.successful) {
        (new Notyf()).confirm(this.$t('settings.update_contact_info_success'));
      }
    }
  }
});



// WEBPACK FOOTER //
// ./resources/assets/js/spark-components/settings/profile/update-contact-information.js